export const FETCH_QUERY_ADMINS_REQUEST = "ADMINS/FETCH_QUERY_REQUEST";
export const FETCH_QUERY_ADMINS_SUCCESS = "ADMINS/FETCH_QUERY_SUCCESS";
export const FETCH_QUERY_ADMINS_FAILURE = "ADMINS/FETCH_QUERY_FAILURE";
